import { NavigationBar } from "../NavigationBar"
import { Container } from "reactstrap"
import { Fragment } from "react";
import { Helmet } from "react-helmet"
export function MainLayout({ children }) {
    return (
        <Fragment>
            <Helmet>
                <style>{`body { background-color: #f5f5f5; }`}</style>
            </Helmet>
            <NavigationBar />
            <Container className="pb-2 position-relative">
                {children}
            </Container>
        </Fragment>
    );
}